import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"24\" height=\"24\" x=\".5\" y=\".5\" fill=\"#fff\" rx=\"12\"></rect><rect width=\"24\" height=\"24\" x=\".5\" y=\".5\" stroke=\"currentColor\" rx=\"12\"></rect><g clip-path=\"url(#a)\"><path fill=\"currentColor\" stroke=\"currentColor\" d=\"M11.555 15.5a.6.6 0 0 1-.398-.152l-2.492-2.297a.5.5 0 0 1-.165-.367.5.5 0 0 1 .164-.367.6.6 0 0 1 .398-.152c.15 0 .292.054.398.151l2.095 1.93 4.984-4.594a.604.604 0 0 1 .796 0 .5.5 0 0 1 .122.169.485.485 0 0 1-.122.566l-5.383 4.961a.6.6 0 0 1-.398.152Z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M21 6.5v12H5v-12z\"></path></clipPath></defs>", 4)
  ])))
}
export default { render: render }